module.exports = __webpack_public_path__ + "static/media/futureup.33e48748.webp";


//////////////////
// WEBPACK FOOTER
// ./src/images/letterfunnel/futureup.webp
// module id = 354
// module chunks = 0